


import React, { useState } from 'react';
import * as translator from "../../utils/translator";
import "./OTCProductRow.css";
import Information from "../../icons/Information.svg";
import InformationGreen from "../../icons/Information-Green.svg";
import QuantityControl from '../QuantityControl/QuantityControl';
import { clientConfig } from '../../config';
import { getPrice } from '../../utils/translator';
import { useCartContext } from '../../customHooks/useCart';
import { useParams } from 'react-router-dom';

type Props = {
    productItem: ProductItem
    shouldShowQuantityControl?: boolean
    incrementButtonOnClick?: () => void
    decrementButtonOnClick?: () => void
    showBin?: boolean
    onInformationToggle?: (open: boolean) => void

}

const OTCProductRowV2: React.FC<Props> = ({ productItem, shouldShowQuantityControl = true, showBin, incrementButtonOnClick, decrementButtonOnClick, onInformationToggle }) => {
    
    const {cartCurrency, getCart} = useCartContext();
    const cart = getCart();
    const [isInformationEnabled, setIsInformationEnabled] = useState<boolean>(false);

    const cartProduct = cart.products.find(product => product.product_item_id === productItem.id);
    const quantity = cartProduct?.quantity || 0;
    const { language } = useParams()

    const isTestLab = !!productItem.is_test_lab;
    // One test kit per order unless several kits are allowed (per-country switch, overridden by the A/B arm):
    // with the rule off, any kit already in the cart (this one or another) blocks "+" on every kit.
    const multipleTestLabKitsAllowed = cart.allow_multiple_test_lab_kits === true;
    const testLabInCart = cart.products.some(product => product.is_test_lab && product.quantity > 0);
    const riskGroupID = cartProduct?.risk_group_id;
    const isRiskGroupBlocked = Boolean(riskGroupID && cart.risk_groups?.some(group => group.id === riskGroupID && group.status !== 'clear'));
    const isIncrementDisabled = (isTestLab && !multipleTestLabKitsAllowed && testLabInCart) || isRiskGroupBlocked;
    return (
        <div className='otc-addons-row-container'>
            <div className='otc-addons-row'>

                <div className='otc-product-image-and-details'>
                    <img className='otc-product-image' src={clientConfig.IMAGES_URL + productItem.imgSrc} alt="product-item" />
                    <div className='otc-product-item-details'>
                        <p className='product-item-details-title'>{productItem.title}</p>
                        {/* TODO:Translations */}

                        {
                            productItem.custom_quantity_title ?
                                <p className='product-item-details-quantity'>{translator.translate(language, "shipping", "otcCartPopup/package")}: {productItem.custom_quantity_title}</p>
                                :
                                null
                        }

                        {
                            quantity ?
                                <p className='product-item-details-quantity'>{translator.translate(language, "default", "OrderWindow/quantity")}: {quantity}</p>
                                :
                                null
                        }

                        <p className='product-item-details-price'>
                            {getPrice(productItem.price * (quantity || 1), cartCurrency.locale, cartCurrency.rate)} <span className='product-item-details-price-discount'> 25% OFF</span>
                        </p>

                        <p className='product-item-details-price-deleted'>
                            {getPrice((productItem.price * (quantity || 1)) / 0.75, cartCurrency.locale, cartCurrency.rate)} 
                        </p>
                    </div>
                </div>


                {
                    shouldShowQuantityControl && incrementButtonOnClick && decrementButtonOnClick?

                        <div className='quantity-control-wrapper'>
                            <button onClick={() => { onInformationToggle?.(!isInformationEnabled); setIsInformationEnabled((current: boolean) => !current); }} className={`product-information-button${isInformationEnabled ? "-enabled" : ""}`}>
                                <img src={isInformationEnabled ? Information : InformationGreen} alt="i" />
                            </button>

                            {
                                shouldShowQuantityControl ?
                                    <QuantityControl
                                        idPrefix={`otc-product-row-${productItem.id}-quantity-control`}
                                        decrementButtonOnClick={decrementButtonOnClick}
                                        quantity={quantity!}
                                        incrementButtonOnClick={incrementButtonOnClick}
                                        isIncrementDisabled={isIncrementDisabled}
                                    />
                                    :
                                    null
                            }

                                </div>
                        :

                        null
                }

            </div>

            {/* Product's Information text */}
            {
                isInformationEnabled ?
                    <div className='information-text-container'>
                        <p className='information-text'>
                            {productItem.description}
                        </p>
                    </div>
                    :
                    null
            }

        </div>

    )
}

export default OTCProductRowV2